import {takeEvery, put, select} from 'redux-saga/effects';
import moment from 'moment/moment';
import {
  GET_ALL_PERIOD_CUSTOMERS_COUNT,
  GET_ALL_PERIOD_CUSTOMERS_COUNT_SUCCESS,
  GET_ALL_PERIOD_TOTAL_SALES,
  GET_ALL_PERIOD_TOTAL_SALES_SUCCESS,
  GET_ANALYTICS_INFO,
  GET_ANALYTICS_INFO_SUCCESS,
  GET_EMAIL_MARKETING_STATS,
  GET_EMAIL_MARKETING_STATS_SUCCESS,
  GET_INSIGHTS_PERFORMANCE,
  GET_INSIGHTS_PERFORMANCE_SUCCESS,
  GET_MANAGE_PRICE_URL,
  GET_MANAGE_PRICE_URL_SUCCESS,
  GET_PREV_WEEK_ALL_PERIOD_CUSTOMERS_COUNT,
  GET_PREV_WEEK_ALL_PERIOD_CUSTOMERS_COUNT_SUCCESS,
  GET_PREV_WEEK_ALL_PERIOD_TOTAL_SALES,
  GET_PREV_WEEK_ALL_PERIOD_TOTAL_SALES_SUCCESS,
  GET_PREV_WEEK_INSIGHTS_PERFORMANCE,
  GET_PREV_WEEK_INSIGHTS_PERFORMANCE_SUCCESS,
  GET_SALES_PER_HOUR,
  GET_SALES_PER_HOUR_SUCCESS,
  GET_SALES_PER_ITEM,
  GET_SALES_PER_ITEM_SUCCESS,
  GET_SURVEY_STATS,
  GET_SURVEY_STATS_SUCCESS,
  GET_SURVEY_STATS_THIS_WEEK,
  GET_SURVEY_STATS_THIS_WEEK_SUCCESS,
  GET_TODAY_TOTAL_SALES,
  GET_TODAY_TOTAL_SALES_SUCCESS,
  GET_TOP_CUSTOMERS,
  GET_TOP_CUSTOMERS_SUCCESS,
  GET_YESTERDAY_TOTAL_SALES,
  GET_YESTERDAY_TOTAL_SALES_SUCCESS,
  SET_LOADING_ALL_PERIOD_CUSTOMERS_COUNT,
  SET_LOADING_ALL_PERIOD_TOTAL_SALES,
  SET_LOADING_ANALYTICS_INFO,
  SET_LOADING_EMAIL_MARKETING_STATS,
  SET_LOADING_GROWTH_INFO,
  SET_LOADING_INSIGHTS_PERFORMANCE,
  SET_LOADING_SALES_PER_HOUR,
  SET_LOADING_SALES_PER_ITEM,
  SET_LOADING_SURVEY_STATS,
  SET_LOADING_TODAY_TOTAL_SALES,
  SET_LOADING_TOP_CUSTOMERS,
  SET_LOADING_YESTERDAY_TOTAL_SALES,
  SETUP_CALL
} from 'store/mainPage/action';
import {
  getCustomersCountApi,
  getSalesCountApi,
  getSalesPerHourApi,
  getSalesPerItemApi
} from 'helpers/services/api/analytics';
import {generateReportApi} from 'helpers/services/api/reports';
import {
  getInsightsGrowthInfo,
  getInsightsPerformanceInfo
} from 'helpers/services/api/insights';
import {getStatisticApi} from 'helpers/services/api/emailMarketing';
import {
  feedbackType,
  FIRST_SURVEY_PRODUCTION_DATE
} from 'routes/App/feedback/constants';
import {getFeedbackStatsApi} from 'helpers/services/api/feedback';
import {mainPageSetupCallApi} from 'helpers/services/api/user';
import {getAnalyticsInfoApi} from '../../helpers/services/api/byocOnboarding';

const activeLocation = (state) => state?.user?.activeLocation;

export function* getTodayTotalSales() {
  try {
    const {Timezone} = yield select(activeLocation);
    const locationDate = moment().utc().add(Number(Timezone), 'hours');

    const {data} = yield getSalesCountApi(
      locationDate?.utc().startOf('day').format(),
      locationDate?.utc().endOf('day').format()
    );
    if (data?.data) {
      yield put(GET_TODAY_TOTAL_SALES_SUCCESS(data.data));
    }
    yield put(SET_LOADING_TODAY_TOTAL_SALES(false));
  } catch (error) {
    yield put(SET_LOADING_TODAY_TOTAL_SALES(false));
    console.log('SAGA ERROR', error);
  }
}
export function* getYesterdayTotalSales() {
  try {
    const {Timezone} = yield select(activeLocation);
    const locationDate = moment().utc().add(Number(Timezone), 'hours');
    const prevDayStart = locationDate
      .clone()
      .subtract(1, 'week')
      .startOf('day')
      .format();
    const prevDayEnd = locationDate
      .clone()
      .subtract(1, 'week')
      .endOf('day')
      .format();

    const {data} = yield getSalesCountApi(prevDayStart, prevDayEnd);
    if (data?.data) {
      yield put(GET_YESTERDAY_TOTAL_SALES_SUCCESS(data.data));
    }
    yield put(SET_LOADING_YESTERDAY_TOTAL_SALES(false));
  } catch (error) {
    yield put(SET_LOADING_YESTERDAY_TOTAL_SALES(false));
    console.log('SAGA ERROR', error);
  }
}

export function* getAllPeriodTotalSales() {
  try {
    const {data} = yield getSalesCountApi(null, null);
    if (data?.data) {
      yield put(GET_ALL_PERIOD_TOTAL_SALES_SUCCESS(data.data));
    }
    yield put(SET_LOADING_ALL_PERIOD_TOTAL_SALES(false));
  } catch (error) {
    yield put(SET_LOADING_ALL_PERIOD_TOTAL_SALES(false));
    console.log('SAGA ERROR', error);
  }
}

export function* getPrevWeekAllPeriodTotalSales() {
  try {
    const {Timezone} = yield select(activeLocation);
    const locationDate = moment().utc().add(Number(Timezone), 'hours');
    const startDate = '2020-01-01T00:00:00Z';
    const endDate = locationDate
      .clone()
      .subtract(1, 'week')
      .endOf('day')
      .format();
    const {data} = yield getSalesCountApi(startDate, endDate);
    if (data?.data) {
      yield put(GET_PREV_WEEK_ALL_PERIOD_TOTAL_SALES_SUCCESS(data.data));
    }
  } catch (error) {
    console.log('SAGA ERROR', error);
  }
}

export function* getAllPeriodCustomersCount() {
  try {
    const {data} = yield getCustomersCountApi(null, null);
    if (data?.data) {
      yield put(GET_ALL_PERIOD_CUSTOMERS_COUNT_SUCCESS(data.data));
    }
    yield put(SET_LOADING_ALL_PERIOD_CUSTOMERS_COUNT(false));
  } catch (error) {
    yield put(SET_LOADING_ALL_PERIOD_CUSTOMERS_COUNT(false));
    console.log('SAGA ERROR', error);
  }
}

export function* getPrevWeekAllPeriodCustomersCount() {
  try {
    const {Timezone} = yield select(activeLocation);
    const locationDate = moment().utc().add(Number(Timezone), 'hours');
    const startDate = '2020-01-01T00:00:00Z';
    const endDate = locationDate
      .clone()
      .subtract(1, 'week')
      .endOf('day')
      .format();
    const {data} = yield getCustomersCountApi(startDate, endDate);
    if (data?.data) {
      yield put(GET_PREV_WEEK_ALL_PERIOD_CUSTOMERS_COUNT_SUCCESS(data.data));
    }
  } catch (error) {
    console.log('SAGA ERROR', error);
  }
}

export function* getSalesPerHour() {
  try {
    const {Timezone} = yield select(activeLocation);
    const {data} = yield getSalesPerHourApi(Timezone, null, null);
    if (data?.data) {
      yield put(GET_SALES_PER_HOUR_SUCCESS(data.data));
    }
    yield put(SET_LOADING_SALES_PER_HOUR(false));
  } catch (error) {
    yield put(SET_LOADING_SALES_PER_HOUR(false));
    console.log('SAGA ERROR', error);
  }
}

export function* getSalesPerItem() {
  try {
    const {data} = yield getSalesPerItemApi(null, null);
    if (data?.data) {
      yield put(GET_SALES_PER_ITEM_SUCCESS(data.data));
    }
    yield put(SET_LOADING_SALES_PER_ITEM(false));
  } catch (error) {
    yield put(SET_LOADING_SALES_PER_ITEM(false));
    console.log('SAGA ERROR', error);
  }
}

export function* getTopCustomers() {
  try {
    const {_id} = yield select(activeLocation);
    const {data} = yield generateReportApi(null, null, _id, 1);

    if (data?.summaries) {
      yield put(GET_TOP_CUSTOMERS_SUCCESS(data.summaries));
    }
    yield put(SET_LOADING_TOP_CUSTOMERS(false));
  } catch (error) {
    yield put(SET_LOADING_TOP_CUSTOMERS(false));
    console.log('SAGA ERROR', error);
  }
}

export function* getInsightsPerformance() {
  try {
    const {_id} = yield select(activeLocation);
    const {data} = yield getInsightsPerformanceInfo(_id, null, null);

    if (data) {
      yield put(GET_INSIGHTS_PERFORMANCE_SUCCESS(data));
    }
    yield put(SET_LOADING_INSIGHTS_PERFORMANCE(false));
  } catch (error) {
    yield put(SET_LOADING_INSIGHTS_PERFORMANCE(false));
    console.log('SAGA ERROR', error);
  }
}

export function* getPrevWeekInsightsPerformance() {
  try {
    const {_id, Timezone} = yield select(activeLocation);
    const locationDate = moment().utc().add(Number(Timezone), 'hours');
    const startDate = '2020-01-01T00:00:00Z';
    const endDate = locationDate
      .clone()
      .subtract(1, 'week')
      .endOf('day')
      .format();
    const {data} = yield getInsightsPerformanceInfo(_id, startDate, endDate);

    if (data) {
      yield put(GET_PREV_WEEK_INSIGHTS_PERFORMANCE_SUCCESS(data));
    }
  } catch (error) {
    console.log('SAGA ERROR', error);
  }
}
export function* getEmailMarketingStats() {
  try {
    const {_id} = yield select(activeLocation);
    const {data} = yield getStatisticApi(_id);

    if (data) {
      yield put(GET_EMAIL_MARKETING_STATS_SUCCESS(data));
    }
    yield put(SET_LOADING_EMAIL_MARKETING_STATS(false));
  } catch (error) {
    yield put(SET_LOADING_EMAIL_MARKETING_STATS(false));
    console.log('SAGA ERROR', error);
  }
}
export function* getSurveyStats() {
  try {
    const {Timezone, createdAt} = yield select(activeLocation);
    const locationDate = () => {
      return moment().utcOffset(Timezone, false).utc();
    };

    const serverStartDate = createdAt || FIRST_SURVEY_PRODUCTION_DATE;
    const serverEndDate = locationDate().endOf('isoWeek').format();

    const {data} = yield getFeedbackStatsApi(
      feedbackType[0],
      serverStartDate,
      serverEndDate
    );
    if (data) {
      yield put(GET_SURVEY_STATS_SUCCESS(data));
    }

    yield put(SET_LOADING_SURVEY_STATS(false));
  } catch (error) {
    yield put(SET_LOADING_SURVEY_STATS(false));
    console.log('SAGA ERROR', error);
  }
}

export function* getSurveyStatsThisWeek() {
  try {
    const {Timezone} = yield select(activeLocation);
    const locationDate = () => {
      return moment().utcOffset(Timezone, false).utc();
    };

    const serverStartDate = locationDate().startOf('isoWeek').format();
    const serverEndDate = locationDate().endOf('isoWeek').format();

    const {data} = yield getFeedbackStatsApi(
      feedbackType[0],
      serverStartDate,
      serverEndDate
    );
    if (data) {
      yield put(GET_SURVEY_STATS_THIS_WEEK_SUCCESS(data));
    }
  } catch (error) {
    console.log('SAGA ERROR', error);
  }
}

function* setupCall({payload}) {
  try {
    yield mainPageSetupCallApi(payload);
  } catch (error) {
    console.log('SAGA ERROR', error);
  }
}

function* getManagePriceUrl() {
  try {
    yield put(SET_LOADING_GROWTH_INFO(true));
    const {_id} = yield select(activeLocation);
    const {data} = yield getInsightsGrowthInfo(_id);
    if (data) {
      yield put(GET_MANAGE_PRICE_URL_SUCCESS(data));
    }
    yield put(SET_LOADING_GROWTH_INFO(false));
  } catch (error) {
    console.log('SAGA ERROR', error);
    yield put(SET_LOADING_GROWTH_INFO(false));
  }
}

function* getAnalyticsInfo() {
  try {
    const {_id} = yield select(activeLocation);
    const request = yield getAnalyticsInfoApi(_id);
    if (request?.data?.data) {
      yield put(GET_ANALYTICS_INFO_SUCCESS(request.data.data));
    }
    yield put(SET_LOADING_ANALYTICS_INFO(false));
  } catch (error) {
    console.log('SAGA ERROR', error);
    yield put(SET_LOADING_ANALYTICS_INFO(false));
  }
}

function* mainPageSaga() {
  yield takeEvery(GET_TODAY_TOTAL_SALES, getTodayTotalSales);
  yield takeEvery(GET_YESTERDAY_TOTAL_SALES, getYesterdayTotalSales);
  yield takeEvery(GET_ALL_PERIOD_TOTAL_SALES, getAllPeriodTotalSales);
  yield takeEvery(
    GET_PREV_WEEK_ALL_PERIOD_TOTAL_SALES,
    getPrevWeekAllPeriodTotalSales
  );
  yield takeEvery(GET_ALL_PERIOD_CUSTOMERS_COUNT, getAllPeriodCustomersCount);
  yield takeEvery(
    GET_PREV_WEEK_ALL_PERIOD_CUSTOMERS_COUNT,
    getPrevWeekAllPeriodCustomersCount
  );
  yield takeEvery(GET_SALES_PER_HOUR, getSalesPerHour);
  yield takeEvery(GET_SALES_PER_ITEM, getSalesPerItem);
  yield takeEvery(GET_TOP_CUSTOMERS, getTopCustomers);
  yield takeEvery(GET_INSIGHTS_PERFORMANCE, getInsightsPerformance);
  yield takeEvery(
    GET_PREV_WEEK_INSIGHTS_PERFORMANCE,
    getPrevWeekInsightsPerformance
  );
  yield takeEvery(GET_EMAIL_MARKETING_STATS, getEmailMarketingStats);
  yield takeEvery(GET_SURVEY_STATS, getSurveyStats);
  yield takeEvery(GET_SURVEY_STATS_THIS_WEEK, getSurveyStatsThisWeek);
  yield takeEvery(SETUP_CALL, setupCall);
  yield takeEvery(GET_MANAGE_PRICE_URL, getManagePriceUrl);
  yield takeEvery(GET_ANALYTICS_INFO, getAnalyticsInfo);
}

export default mainPageSaga;
